var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColonImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.403809 11.0513C0.403809 10.6021 0.557292 10.224 0.864258 9.91699C1.17122 9.61003 1.58675 9.45654 2.11084 9.45654C2.63493 9.45654 3.05046 9.61003 3.35742 9.91699C3.66439 10.224 3.81787 10.6021 3.81787 11.0513C3.81787 11.493 3.66439 11.8674 3.35742 12.1743C3.05046 12.4738 2.63493 12.6235 2.11084 12.6235C1.58675 12.6235 1.17122 12.4738 0.864258 12.1743C0.557292 11.8674 0.403809 11.493 0.403809 11.0513ZM0.415039 1.62891C0.415039 1.17969 0.568522 0.801595 0.875488 0.494629C1.18245 0.187663 1.59798 0.0341797 2.12207 0.0341797C2.64616 0.0341797 3.06169 0.187663 3.36865 0.494629C3.67562 0.801595 3.8291 1.17969 3.8291 1.62891C3.8291 2.07064 3.67562 2.44499 3.36865 2.75195C3.06169 3.05143 2.64616 3.20117 2.12207 3.20117C1.59798 3.20117 1.18245 3.05143 0.875488 2.75195C0.568522 2.44499 0.415039 2.07064 0.415039 1.62891Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColonImage);
export default __webpack_public_path__ + "static/media/ColonImage.d4ae346d7de4dbfc100290efac7a3cd1.svg";
export { ForwardRef as ReactComponent };